import * as React from 'react';

export default props => (
    <svg
        viewBox="0 0 459 459"
        {...props}
    >
        <g>
            <g>
                <path d="M0,229.5c0,56.1,22.95,107.1,61.2,142.8L0,433.5h153v-153l-56.1,56.1C68.85,311.1,51,272.85,51,229.5
                    c0-66.3,43.35-122.4,102-145.35v-51C66.3,56.1,0,135.15,0,229.5z M204,357h51v-51h-51V357z M459,25.5H306v153l56.1-56.1
                    c28.051,25.5,45.9,63.75,45.9,107.1c0,66.3-43.35,122.4-102,145.35V428.4c86.7-22.95,153-102,153-196.351
                    c0-56.1-22.95-107.1-61.2-142.8L459,25.5z M204,255h51V102h-51V255z"/>
            </g>
        </g>
    </svg>
)